import { PayloadAction, createAsyncThunk, createSlice } from "@reduxjs/toolkit";

import { PostOrderObj, PostOrderState } from "../../types/types";

const SLICE_NAME = "postOrder";

export const postOrder = createAsyncThunk<PostOrderObj, PostOrderObj>(
  `${SLICE_NAME}/submit`,
  async (orderData, { rejectWithValue }) => {
    try {
      if (!orderData || Object.keys(orderData).length === 0) {
        throw new Error("Нет данных для отправки");
      }

      const API_URL = process.env.REACT_APP_URL_BACKEND;
      const response = await fetch(`${API_URL}/api/v1/orders/`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(orderData),
      });

      if (!response.ok) {
        const errorText = await response.text();

        return rejectWithValue(`Ошибка при отправке заказа: ${errorText}`);
      }

      const result: PostOrderObj = await response.json();

      return result;
    } catch (error: unknown) {
      if (error instanceof Error) {
        return rejectWithValue(error.message);
      }

      return rejectWithValue("Неизвестная ошибка при отправке заказа");
    }
  }
);

const initialState: PostOrderState = {
  order: [],
  loading: false,
  error: null,
};

const postOrderSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postOrder.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(postOrder.fulfilled, (state, action: PayloadAction<PostOrderObj>) => {
        state.loading = false;
        state.order.push(action.payload);
      })
      .addCase(postOrder.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export const selectOrder = (state: { postOrder: PostOrderState }) => state.postOrder.order;

export const selectLoading = (state: { postOrder: PostOrderState }) => state.postOrder.loading;

export const selectError = (state: { postOrder: PostOrderState }) => state.postOrder.error;

export default postOrderSlice.reducer;
